import {Card} from "./Card";
import {CardAnimation} from "./CardAnimation";
import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class CardsHandAnimation extends PIXI.Container {

    private static readonly ANIMATION_CONFIG = {
        NAME: "cardsHand",
        STATES: {
            IDLE_ALL_CARDS: "idle_all_cards",
            IDLE_BRAILED_PREFIX: "idle_brailed_",
            BRAIL_CARDS_PREFIX: "brail_cards_",
            EXPAND_CARDS_PREFIX: "expand_",
        },
        SLOT_CONTAINERS: {
            CARD_CONTAINER_PREFIX: "card",
        },
    };

    private readonly FIRST_CARD_POSITION = 252;
    private readonly REGULAR_CARDS_OFFSET = 12;
    private readonly MAX_CARD_AMOUNT = 22;

    private cardsHandAnimation: CustomSpineAnimation;
    private currentCards: Array<CardAnimation> = [];
    private handBrailed: boolean = false;

    constructor() {
        super();
        this.createAndAddCardsHandAnimation();
        this.removeAllCardsFromHand();
    }

    public async playExpandCards(): Promise<void> {
        if (this.currentCards.length > 6) {
            await this.cardsHandAnimation.playThanResolveOnAnimationCompleteAndRemoveAllListeners(
                CardsHandAnimation.ANIMATION_CONFIG.STATES.EXPAND_CARDS_PREFIX + this.currentCards.length);
        }
        this.handBrailed = false;
    }

    public async playBrailCards(): Promise<void> {
        if (this.currentCards.length > 6) {
            await this.cardsHandAnimation.playThanResolveOnAnimationCompleteAndRemoveAllListeners(
                CardsHandAnimation.ANIMATION_CONFIG.STATES.BRAIL_CARDS_PREFIX + this.currentCards.length);
        }
        this.handBrailed = true;
    }

    public playIdleAllCards(): void {
        this.cardsHandAnimation.play(CardsHandAnimation.ANIMATION_CONFIG.STATES.IDLE_ALL_CARDS);
        this.handBrailed = false;
    }

    public playIdleBrailedCards(): void {
        if (this.currentCards.length > 6) {
            this.cardsHandAnimation.play(
                CardsHandAnimation.ANIMATION_CONFIG.STATES.IDLE_BRAILED_PREFIX + this.currentCards.length);
        }
        this.handBrailed = true;
    }

    public addCard(card: Card): void {
        const cardAnimation = new CardAnimation();
        cardAnimation.setCardFront(card.getColor(), card.getName());
        cardAnimation.showUncoveredCard();
        cardAnimation.scale.x = -Math.abs(cardAnimation.scale.x);
        this.currentCards.unshift(cardAnimation);
        this.redrawCards();
    }

    public getCurrentCardPosition(): PIXI.Point {
        if (this.handBrailed && this.currentCards.length > 4) {
            return new PIXI.Point(
                (3 * this.REGULAR_CARDS_OFFSET) + (this.currentCards.length - 4) * 2,
                0);
        } else {
            return new PIXI.Point((this.currentCards.length - 1) * this.REGULAR_CARDS_OFFSET, 0);
        }
    }

    public isBrailed(): boolean {
        return this.handBrailed;
    }

    public getNextCardPosition(): PIXI.Point {
        return new PIXI.Point(this.currentCards.length * this.REGULAR_CARDS_OFFSET, 0);
    }

    public removeAllCardsFromHand(): void {
        for (let i = 0; i < this.MAX_CARD_AMOUNT; i++) {
            this.cardsHandAnimation.getSlotContainer(
                CardsHandAnimation.ANIMATION_CONFIG.SLOT_CONTAINERS.CARD_CONTAINER_PREFIX + i, true);
        }
        this.currentCards = [];
    }

    private redrawCards(): void {
        let container;

        for (let i = 0; i < this.currentCards.length; i++) {
            container = this.cardsHandAnimation.getSlotContainer(
                CardsHandAnimation.ANIMATION_CONFIG.SLOT_CONTAINERS.CARD_CONTAINER_PREFIX + i, true);
            this.currentCards[i].scale.x = -Math.abs(this.currentCards[i].scale.x);
            container.addChild(this.currentCards[i]);
        }
        this.cardsHandAnimation.position.x = -(this.FIRST_CARD_POSITION -
            ((this.currentCards.length - 1) * this.REGULAR_CARDS_OFFSET));
    }

    private createAndAddCardsHandAnimation(): void {
        this.cardsHandAnimation = new CustomSpineAnimation(CardsHandAnimation.ANIMATION_CONFIG.NAME);
        this.addChild(this.cardsHandAnimation);
    }
}



// WEBPACK FOOTER //
// ./src/app/CardsHandAnimation.ts